"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "dashboardCtrl",
    function (
      $scope,
      $filter,
      model,
      Dashboard,
      permissionService,
      requiredApprovals
    ) {
      var vm = this;

      var $translate = $filter("translate");

      vm.permissions = permissionService;

      angular.extend($scope.$parent.vm, {
        title: null,
        insertUrl: null,
      });

      vm.model = model;
      vm.requiredApprovals = requiredApprovals;
    }
  );
